import { render, staticRenderFns } from "./FactoryVideoUpload.vue?vue&type=template&id=09053984"
import script from "./FactoryVideoUpload.vue?vue&type=script&lang=js"
export * from "./FactoryVideoUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports